import Decimal from 'decimal.js'

import type { IntegerFilter } from 'generated/resources/graphql'
import type { FilterValue, NumberFilterDefinition } from '@factorialco/f0-react/dist/experimental'

type NumberFilterValue = FilterValue<NumberFilterDefinition>

const convertValue = (value: number | undefined, convertToCents: boolean): number | undefined => {
  if (value === undefined) return undefined
  return convertToCents ? new Decimal(value).times(100).toNumber() : value
}

export const mapNumberFilterValueToIntegerFilter = (
  numberFilterValue: NumberFilterValue,
  convertToCents = true
): IntegerFilter | undefined => {
  if (!numberFilterValue) return undefined

  if (numberFilterValue.mode === 'single') {
    const value = convertValue(numberFilterValue.value, convertToCents)
    return value !== undefined ? { eq: value } : undefined
  }

  if (numberFilterValue.mode === 'range') {
    const filter: IntegerFilter = {}
    if (numberFilterValue.from.value !== undefined) {
      const fromOperator = numberFilterValue.from.closed ? 'gteq' : 'gt'
      filter[fromOperator] = convertValue(numberFilterValue.from.value, convertToCents)
    }
    if (numberFilterValue.to.value !== undefined) {
      const toOperator = numberFilterValue.to.closed ? 'lteq' : 'lt'
      filter[toOperator] = convertValue(numberFilterValue.to.value, convertToCents)
    }
    return filter
  }
}
